<div class="container min-h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Algemeen</h2>
  </div>

  <form class="flex flex-col gap-12" [formGroup]="form">
    <div class="grid lg:grid-cols-3 gap-4">
      <div>
        <div class="font-medium">Unit</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          De naam waarmee je deze unit herkent in de applicatie.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="grid grid-cols-6 gap-4 max-w-2xl">
            <div class="col-span-full lg:col-span-4">
              <div class="space-y-2">
                <label for="name" class="block font-medium text-sm select-none"
                  >Naam unit</label
                >

                <mat-form-field class="w-full">
                  <input
                    matInput
                    formControlName="name"
                    autocomplete="off"
                    enterkeyhint="next"
                    id="name"
                    type="text"
                  />

                  @if (controls.name.hasError('required')) {
                    <mat-error>Dit veld is verplicht</mat-error>
                  } @else if (controls.name.hasError('maxlength')) {
                    <mat-error
                      >Max.
                      {{ controls.name.getError('maxlength').requiredLength }}
                      karakters</mat-error
                    >
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid lg:grid-cols-3 gap-4">
      <div>
        <div class="font-medium">Adresgegevens</div>
        <div class="text-sm text-pretty text-gray-700 mt-1">
          Het fysieke adres van je unit of locatie. Optioneel, maar vul je iets in,
          dan zijn alle adresvelden verplicht.
        </div>
      </div>
      <div class="col-span-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="grid lg:grid-cols-6 gap-4 max-w-2xl" formGroupName="address">
            <div class="space-y-2 lg:col-span-4">
              <label for="streetName" class="block font-medium text-sm select-none"
                >Straat</label
              >

              <mat-form-field class="w-full">
                <input
                  matInput
                  formControlName="streetName"
                  autocomplete="street-address"
                  enterkeyhint="next"
                  id="streetName"
                  type="text"
                />

                @if (addressControls.streetName.hasError('required')) {
                  <mat-error>Dit veld is verplicht</mat-error>
                } @else if (addressControls.streetName.hasError('maxlength')) {
                  <mat-error
                    >Max.
                    {{
                      addressControls.streetName.getError('maxlength').requiredLength
                    }}
                    karakters</mat-error
                  >
                }
              </mat-form-field>
            </div>

            <div class="space-y-2 lg:col-span-2">
              <label for="houseNumber" class="block font-medium text-sm select-none"
                >Huisnr.</label
              >

              <mat-form-field class="w-full">
                <input
                  matInput
                  formControlName="houseNumber"
                  autocomplete="street-address"
                  enterkeyhint="next"
                  id="houseNumber"
                  type="text"
                />

                @if (addressControls.houseNumber.hasError('required')) {
                  <mat-error>Dit veld is verplicht</mat-error>
                } @else if (addressControls.houseNumber.hasError('maxlength')) {
                  <mat-error
                    >Max.
                    {{
                      addressControls.houseNumber.getError('maxlength').requiredLength
                    }}
                    karakters</mat-error
                  >
                }
              </mat-form-field>
            </div>

            <div class="space-y-2 lg:col-span-2">
              <label for="zipcode" class="block font-medium text-sm select-none"
                >Postcode</label
              >

              <mat-form-field class="w-full">
                <input
                  matInput
                  formControlName="zipcode"
                  autocomplete="postal-code"
                  enterkeyhint="next"
                  id="zipcode"
                  type="text"
                />

                @if (addressControls.zipcode.hasError('required')) {
                  <mat-error>Dit veld is verplicht</mat-error>
                } @else if (addressControls.zipcode.hasError('invalidZipcode')) {
                  <mat-error>Geen geldige postcode</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="space-y-2 lg:col-span-4">
              <label for="city" class="block font-medium text-sm select-none"
                >Plaats</label
              >

              <mat-form-field class="w-full">
                <input
                  matInput
                  formControlName="city"
                  autocomplete="address-level2"
                  enterkeyhint="next"
                  id="city"
                  type="text"
                />

                @if (addressControls.city.hasError('required')) {
                  <mat-error>Dit veld is verplicht</mat-error>
                } @else if (addressControls.city.hasError('maxlength')) {
                  <mat-error
                    >Max.
                    {{ addressControls.city.getError('maxlength').requiredLength }}
                    karakters</mat-error
                  >
                }
              </mat-form-field>
            </div>

            <div class="space-y-2 lg:col-span-4">
              <label for="province" class="block font-medium text-sm select-none"
                >Provincie</label
              >

              <mat-form-field class="w-full">
                <input
                  matInput
                  formControlName="province"
                  autocomplete="address-level1"
                  enterkeyhint="next"
                  id="province"
                  type="text"
                />

                @if (addressControls.province.hasError('required')) {
                  <mat-error>Dit veld is verplicht</mat-error>
                } @else if (addressControls.province.hasError('maxlength')) {
                  <mat-error
                    >Max.
                    {{ addressControls.province.getError('maxlength').requiredLength }}
                    karakters</mat-error
                  >
                }
              </mat-form-field>
            </div>

            <div class="space-y-2 lg:col-span-2">
              <label for="country" class="block font-medium text-sm select-none"
                >Land</label
              >

              <mat-form-field class="w-full">
                <mat-select formControlName="country">
                  <mat-option value="NL">Nederland</mat-option>
                </mat-select>

                @if (addressControls.country.hasError('required')) {
                  <mat-error>Dit veld is verplicht</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid lg:grid-cols-3 gap-4">
      <div class="col-span-2 lg:col-start-2 bg-white rounded-lg">
        <div class="p-8">
          <div class="flex flex-col gap-8">
            <div class="flex flex-col items-start gap-4 lg:flex-row lg:items-center">
              <div class="space-y-2 flex-1">
                <div class="font-medium">Unit verwijderen</div>
                <div class="text-sm text-pretty text-gray-700 mt-1 max-w-prose">
                  Het verwijderen van een unit is definitief. Wees zeker van je keuze
                  voordat je verder gaat.
                </div>
              </div>

              <div
                *appHasPermission="'unit:delete'"
                [matTooltip]="deleteUnitTooltip()"
                [matTooltipDisabled]="canDeleteUnit()"
              >
                <button
                  mat-stroked-button
                  type="button"
                  class="[--mat-sys-primary:var(--color-red-500)]"
                  [disabled]="!canDeleteUnit()"
                  (click)="handleUnitDelete()"
                >
                  Verwijder unit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *appHasPermission="'unit:update'" class="flex justify-end">
      <button
        mat-flat-button
        type="submit"
        [disabled]="form.invalid || submitted()"
        (click)="handleSubmit()"
      >
        Opslaan
      </button>
    </div>
  </form>
</div>
